import { useQuery } from "@tanstack/react-query";

import { getExchangeRates } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { EXCHANGE_RATES_QUERY_KEYS } from "./queryKeys";

const ONE_HOUR = 60 * 60 * 1000;

export function useExchangeRatesQuery(enabled = true) {
  return useQuery({
    queryKey: EXCHANGE_RATES_QUERY_KEYS.all,
    queryFn: processResponse(() => getExchangeRates()),
    staleTime: ONE_HOUR,
    enabled,
  });
}
